<template>
  <BModal
    active
    class="new-customer"
    @close="cancelModal"
  >
    <header class="modal-card-head">
      <p class="modal-card-title has-text-primary">
        {{ clientName }}
      </p>
    </header>

    <div class="modal-card-body">
      <div class="column is-12">
        <BField
          label="Límite de crédito necesario"
          label-for="customerDebtLimit"
        >
          {{ limit || 0 }}
        </BField>
      </div>
      <div class="column is-12">
        <BField
          label="Deuda Actual"
          label-for="customerDebt"
        >
          {{ debt || 0 }}
        </BField>
      </div>
      <div class="column is-12">
        <BField
          label="Limite de crédito"
          label-for="privateCreditLimit"
        >
          <BInput
            id="privateCreditLimit"
            v-model="privateCreditLimit"
            placeholder="30"
            icon="bank"
            required
            @input="onInput('creditLimit', $event)"
          />
        </BField>
        <p class="help">
          {{ privateCreditLimit | toCurrency('MXN') }}
        </p>
      </div>
    </div>
    <footer class="modal-card-foot">
      <p class="control">
        <button
          class="button is-success"
          @click="closeModal(true)"
        >
          Guardar
        </button>
        <button
          class="button"
          type="button"
          @click="closeModal(false)"
        >
          Cerrar
        </button>
      </p>
    </footer>
  </BModal>
</template>

<script>
import merge from 'lodash/merge';

import {
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  name: 'LimitCreditModal',
  props: {
    limit: {
      type: String,
      default: '',
    },
    debt: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      privateCreditLimit: this.$store.state.customers.creditLimit,
      customer: this.$store.state.customers,
    };
  },
  computed: merge(
    mapState({
      clientName: ({ customers }) => customers.name,
    }),
    {
      lastPage() {
        return Math.ceil(this.invoices.length / this.itemsPerPage);
      },
      currentPage() {
        return parseInt(this.currentPageState, 10);
      },
      size() {
        return this.$route.query.size;
      },
    },
  ),
  watch: {
    buttonsMax(newValue, oldValue) {
      if (newValue % 2) {
        return;
      }
      if (newValue < oldValue) {
        this.buttonsMax = newValue - 1;
      }
      if (newValue > oldValue) {
        this.buttonsMax = newValue + 1;
      }
    },
  },

  methods: merge(
    mapMutations({
      addDocument: 'invoice/addDocument',
      setDocumentValue: 'invoice/updateDocument',
      setValue: 'invoices/setValue',
    }),
    mapActions({ search: 'invoices/search' }),
    {
      cancelModal() {
        this.$emit('close', true);
      },
      async closeModal(save) {
        this.$emit('close', true);
        if (save) {
          try {
            await this.$store.dispatch('customers/update');
            this.$success({ message: 'El cliente se actualizó exitosamente' });
          } catch (error) {
            console.log(error);
          }
        }
      },
      onInput(name, event) {
        this.$store.commit('customers/setValue', { accessor: name, value: event });
      },
    },
  ),
};
</script>

<style scoped>
@media screen and (min-width: 769px) {
  form {
    flex-grow: 0.5;
  }
}
</style>

<style>
.modal-card-title {
  flex-grow: 0.45;
}
.control {
  flex-grow: 0.35;
}
.user-bulk-upload .upload-draggable.is-primary {
  width: 100%;
}
.help {
  color: #f5f5f5;
}
</style>
